export const MAXIMUM_WEBSITE_LENGTH = 255;

/**
 * Mirrors `normaliseWebsite` in admin-gateway, which has the final say: a website may be typed
 * without a scheme (it is saved as https), but must otherwise be an http(s) address on a
 * dotted host.
 */
export const isValidWebsite = (website: string) => {
  const trimmed = website.trim();
  const withScheme = hasScheme(trimmed) ? trimmed : `https://${trimmed}`;
  if (withScheme.length > MAXIMUM_WEBSITE_LENGTH) return false;

  const url = parseUrl(withScheme);

  return (
    url !== undefined &&
    (url.protocol === "http:" || url.protocol === "https:") &&
    url.hostname.includes(".")
  );
};

const hasScheme = (website: string) => /^[a-z][a-z\d+.-]*:\/\//i.test(website);

const parseUrl = (website: string) => {
  try {
    return new URL(website);
  } catch {
    return undefined;
  }
};
